import getScore from '@opsbase/lib-form/helpers/getScore';
import scoreColor from '@opsbase/lib-grading/scoreColor';
import Palette from '@opsbase/lib-palette';
import useAltForSelfLang from '@opsbase/react-ctrl-self/helpers/useAltForSelfLang';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import useCss from '@opsbase/web-css/useCss/useCss';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Text from '@opsbase/web-ui/Text';
import Tooltip from '@opsbase/web-ui/Tooltip/Tooltip';
import React from 'react';
const makeMyClasses = () => ({
    scoring: {
        backgroundColor: Palette.WhiteSmoke.main,
        boxShadow: `4px 4px 4px ${Palette.LavendarGrey.main}`,
        marginBottom: 10,
        borderRadius: 10,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: Palette.BorderGrey.main,
        fontSize: 14,
        lineHeight: '14px',
    },
});
export function OpViewOverviewSectionScore(props) {
    var _a;
    const { op, onClick, section } = props;
    const myCss = useCss(makeMyClasses);
    const parsedForm = op.getParsedForm();
    const [sectionTitle] = useAltForSelfLang(section.title, section.titleAlt);
    const isSectionSkipped = (_a = parsedForm.answers[section.qId]) === null || _a === void 0 ? void 0 : _a.notApplicable;
    const sectionScore = isSectionSkipped
        ? { total: 0, max: 1 }
        : getScore(parsedForm, parsedForm.questions[section.qId]);
    const scoreTotal = sectionScore.total;
    const scoreMax = sectionScore.max || 1;
    const value = Math.round((((scoreTotal || 0) / scoreMax) * 100 + Number.EPSILON) * 100) / 100;
    const tip = (scoreTotal || 0) + ' / ' + scoreMax;
    const handleClick = useCallforward(id => () => onClick(id), [onClick]);
    if (!op.isScoreEnabled && sectionScore.max > 0)
        return React.createElement(React.Fragment, null);
    return (React.createElement(Horizontal, { gutter: true, onClick: handleClick(section.qId), classes: { root: myCss.scoring }, padding: true },
        React.createElement(Pane, null,
            React.createElement(Tooltip, { tip: sectionTitle },
                React.createElement(Text, { withEllipsis: true, style: { width: 180 } }, sectionTitle))),
        React.createElement(Pane, null,
            React.createElement(Tooltip, { tip: tip },
                React.createElement(Text, { color: scoreColor(value) },
                    value + '%',
                    " ")))));
}
export default OpViewOverviewSectionScore;
